module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/QRlogoOrange.9b54b4f882e414747135a0545fab44fa.svg";